const COMPLETED = 'completed';
const WAIT = 'wait';

export { COMPLETED, WAIT };
